import { Component } from '@angular/core';
import { CardPromotionComponent } from '../../components/card-promotion/card-promotion.component';
@Component({
  selector: 'app-promotions',
  standalone: true,
  imports: [CardPromotionComponent],
  templateUrl: './promotions.component.html',
  styleUrl: './promotions.component.scss'
})
export class PromotionsComponent {

}
